import React from 'react';
import '../Touch/Touch.css';
import { FaPhone } from 'react-icons/fa';
const callAdmin = () => {
  window.location.href = 'tel: +9100000000'; // replace with real number
};
const Touch = () => {
  return (
    <div className="touch-section">
      <div className="touch-overlay">
        <div className="touch-left">
          <p className="touch-quote">
            All people are equal before the law.<br />
            <span className="highlight">A good Lawyer Firm</span> is what makes a difference.
          </p>
        </div>

        <div className="touch-right">
          <div className="touch-contact">
            <div className="icon-circle">
              <FaPhone className="phone-icon" />
            </div>
            <div className="contact-text">
              <p className="get-in-touch">Get in touch</p>
              <p className="phone-number" onClick={callAdmin}>123 456 7890</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Touch;